<template>
  <BannerCard
    :icon="PromoBadgeIcon"
    :title="$t('plus_promo_badge')"
    :hint="$t('promo_badge_tooltip')"
    :withHint="true"
    type="promo-badge"
    :isActionable="true"
  >
    <template #cardData>
      <div
        class="tw:font-bold tw:text-sm tw:px-2 tw:py-1 tw:rounded"
        :class="hasActiveOffer ? 'tw:bg-green-200 tw:text-green-700' : 'tw:bg-gray-200 tw:text-gray-600'"
      >
        {{ hasActiveOffer ? $t('promo_badge_active') : $t('promo_badge_inactive') }}
      </div>
    </template>
    <template #dropdownMenu>
      <div class="tw:text-sm tw:hover:bg-blue-200 tw:hover:text-blue-800 tw:rounded-lg tw:flex">
        <router-link
          class="tw:hover:no-underline tw:px-4 tw:py-3 tw:w-full"
          :to="hasActiveOffer ? { name: 'hotel-offers' } : { name: 'hotel-offers', query: { create_offer: 'true' } }"
          @click="logEvent"
        >
          {{ $t('go_hotel_offers_cta') }}
        </router-link>
      </div>
    </template>
  </BannerCard>
</template>
<script setup>
import BannerCard from '@/components/studioPlus/insights/BannerCard.vue'

import { useActiveOffer } from '@/components/hotelOffers/queries'
import { selectedAccommodationId } from '@/layouts/queries'

import appAnalytics from '@/utils/tracking'

const PromoBadgeIcon = new URL('/src/assets/img/studio-plus-insights/hotel-offers-icon.svg', import.meta.url)

const { hasActiveOffer } = useActiveOffer(selectedAccommodationId)

const logEvent = () => {
  appAnalytics.track(appAnalytics.events.SP_PLUS_INSIGHTS_STATUS_INDICATOR_CLICKED, {
    item_id: selectedAccommodationId.value,
    menu_type: 'go_to_hotel_offers',
  })
}
</script>
